export const EDIT_ACCOUNT_FIELD = 'EDIT_ACCOUNT_FIELD'
export const FLAG_ACCOUNT_ERRORS = 'FLAG_ACCOUNT_ERRORS'
export const UNFLAG_ACCOUNT_ERRORS = 'UNFLAG_ACCOUNT_ERRORS'
export const SUBMIT_ACCOUNT_FAIL = 'SUBMIT_ACCONT_FAIL'
export const SUBMIT_ACCOUNT_SUCCESS = 'SUBMIT_ACCOUNT_SUCCESS'